/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CancelledInputs */

const cs_enum_cancelled = /** @type {(inputs: Enum_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušeno`)
};

const en_enum_cancelled = /** @type {(inputs: Enum_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Enum_CancelledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_cancelled = /** @type {((inputs?: Enum_CancelledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CancelledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_cancelled(inputs)
	return cs_enum_cancelled(inputs)
});